import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import { useHistory } from "react-router-dom";
import Type from "@actionTypes";
import SiderMenu from "../components/Menu";
import { Button } from "antd";
export default function Page1() {
  const dispatch = useDispatch()
  const count = useSelector(state => state.app.count)
  const addCount = () => {
      dispatch({ type: Type.ADD_COUNT })
  }

  const history = useHistory();
  const goto = () => {
      history.push('/page2');
  }

  return (
    <div>
      <SiderMenu/>
      <Button onClick={addCount}>count+1</Button>
      <Button onClick={goto}>go to Page2</Button>
      <p>{count}</p>
    </div>
  );
}
